






































































































import Vue from 'vue'
import { ReimbursementService } from '@/api/services/reimbursements'

export default Vue.extend({
  props: {
    reimbursement: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      resyncing: false,
      resyncMessage: '',
      resyncOk: false,
      currentState:
        (this.reimbursement && (this.reimbursement as any).state) || ''
    }
  },

  computed: {
    beneficiaryName(this: any): string {
      const r = this.reimbursement
      return r.beneficiaryName || (r.beneficiary && r.beneficiary.name) || '--'
    }
  },

  methods: {
    async resync(this: any) {
      this.resyncing = true
      this.resyncMessage = ''
      try {
        const result = await ReimbursementService.checkStatus(
          this.reimbursement.id
        )
        this.resyncOk = !!result.success
        this.resyncMessage = result.message
          ? result.message
          : `Statut KKiaPay: ${result.kkiapayStatus || '--'} → ${result.state ||
              '--'}`
        if (result.state) {
          this.currentState = result.state
        }
        this.$emit('resynced', result)
      } catch (error) {
        this.resyncOk = false
        this.resyncMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Erreur lors de la resynchronisation'
      } finally {
        this.resyncing = false
      }
    },

    statusLabel(state: string): string {
      if (state === 'paid') return 'Succès'
      if (state === 'failed') return 'Échec'
      return 'En attente'
    },
    statusTextClass(state: string): string {
      if (state === 'paid') return 'text-green-500'
      if (state === 'failed') return 'text-danger'
      return 'text-yellow-600'
    }
  }
})
